import * as yup from 'yup';

export const getEmployeeDetailSchema = (isPhoneRequired: boolean) => {
  return yup.object({
    first_name: yup.string().required('First name is required.'),
    last_name: yup.string().required('Last name is required.'),
    email: yup.string().email().required('A valid email is required.'),
    mobile_number: isPhoneRequired
      ? yup.string().required('A valid mobile number is required')
      : yup.string(),
    department_id: yup.number().required('Department is required.'),
    // role: yup.string().required('Role is required'),
    employee_code: yup.string(),
    cost_center_id: yup.number(),
    expense_codes: yup.array().of(yup.number())
  });
};

export type EmployeeFormValues = yup.InferType<
  ReturnType<typeof getEmployeeDetailSchema>
>;
